module.exports = __webpack_public_path__ + "static/media/icons_Les Essentiels - bilan cheville - pied.b7c20ec4.svg";